export const personalData = {
  name: "Mitch Brey",
  title: "Operations Manager & Sustainability Advocate",
  tagline: "Expanding access to clean energy, supporting people with disabilities, and strengthening community-based organizations.",
  bio: [
    "Mitch Brey is a nonprofit professional and sustainability advocate with a career centered on expanding access to clean energy, supporting people with disabilities, and strengthening community‑based organizations. He studied biochemistry at the University of Wisconsin–Madison before shifting from research to hands‑on work aimed at improving people’s everyday lives.",
    "Mitch spent three years as a case manager for adults with developmental disabilities at Community Living Connections before transitioning into the clean energy sector, where he worked with Focus on Energy conducting residential energy assessments. He later served as a campaign organizer with RePower Madison, helping residents engage more directly in local energy planning and advocating for a faster transition to renewable energy.",
    "Mitch joined the Wisconsin Council of the Blind & Vision Impaired in 2019, where he has played a key role in keeping the organization running smoothly. From managing front‑desk staff and supporting technology needs to assisting in the Sharper Vision Store and contributing to advocacy efforts, Mitch has become one of the essential people who keep the Council humming day in and day out.",
    "Across his roles, Mitch is known for his ability to problem‑solve, work collaboratively, and approach challenges from multiple perspectives. He brings experience from nonprofits of all sizes, along with a deep commitment to equity, sustainability, and community empowerment—values that guide his interest in net‑zero affordable housing development."
  ],
  experience: [
    {
      role: "President",
      company: "Sunny Side Development Board",
      period: "Current",
      description: "Leading strategic initiatives for affordable housing development with a focus on net-zero sustainability."
    },
    {
      role: "Operations Manager / Key Staff",
      company: "Wisconsin Council of the Blind & Vision Impaired",
      period: "2019 - Present",
      description: "Managing front-desk staff, supporting technology needs, assisting in the Sharper Vision Store, and contributing to advocacy efforts. Essential in daily operations."
    },
    {
      role: "Campaign Organizer",
      company: "RePower Madison",
      period: "Previous",
      description: "Helped residents engage in local energy planning and advocated for faster transition to renewable energy."
    },
    {
      role: "Energy Assessor",
      company: "Focus on Energy",
      period: "Previous",
      description: "Conducted residential energy assessments to improve efficiency."
    },
    {
      role: "Case Manager",
      company: "Community Living Connections",
      period: "3 Years",
      description: "Supported adults with developmental disabilities."
    }
  ],
  education: {
    degree: "Biochemistry",
    school: "University of Wisconsin–Madison"
  },
  skills: [
    "Nonprofit Management",
    "Operations & Logistics",
    "Sustainability Strategy",
    "Community Organizing",
    "Team Leadership",
    "Problem Solving",
    "Equity & Inclusion",
    "Technology Support"
  ],
  interests: [
    "Running",
    "Gardening",
    "Board Games",
    "Community Festivals",
    "Farmers' Markets"
  ]
};
